import { BrandingProvider } from "@/context/BrandingContext";
import BrandingSettings from "@/pages/BrandingSettings";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PublicOnly from "@/components/PublicOnly";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Overview from "@/pages/Overview";
import Projects from "@/pages/Projects";
import Rooms from "@/pages/Rooms";
import RoomDetail from "@/pages/RoomDetail";
import ApiKeys from "@/pages/ApiKeys";
import Usage from "@/pages/Usage";
import Members from "@/pages/Members";
import QuickStart from "@/pages/QuickStart";
import Plan from "@/pages/Plan";
import Settings from "@/pages/Settings";
import PlatformAdmin from "@/pages/PlatformAdmin";
import Communications from "@/pages/Communications";
import Recordings from "@/pages/Recordings";
import Delegations from "@/pages/Delegations";
import Workspaces from "@/pages/Workspaces";
import Organizations from "@/pages/Organizations";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-zinc-700 border-t-zinc-200 animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <BrandingProvider><AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/admin" element={<Protected><PlatformAdmin /></Protected>} />
          <Route
            path="/dashboard"
            element={
              <Protected>
                <WorkspaceProvider>
                  <DashboardLayout />
                </WorkspaceProvider>
              </Protected>
            }
          >
            <Route index element={<Overview />} />
            <Route path="branding" element={<BrandingSettings />} />
            <Route path="recordings" element={<Recordings />} />
            <Route path="delegations" element={<Delegations />} />
            <Route path="calls" element={<Communications kind="calls" />} />
            <Route path="meetings" element={<Communications kind="meetings" />} />
            <Route path="workspaces" element={<Workspaces />} />
            <Route path="organizations" element={<Organizations />} />
            <Route path="projects" element={<Projects />} />
            <Route path="rooms" element={<Rooms />} />
            <Route path="rooms/:roomId" element={<RoomDetail />} />
            <Route path="api-keys" element={<ApiKeys />} />
            <Route path="usage" element={<Usage />} />
            <Route path="plan" element={<Plan />} />
            <Route path="members" element={<Members />} />
            <Route path="quickstart" element={<QuickStart />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider></BrandingProvider>
    </BrowserRouter>
  );
}

export default App;
